import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import CosmicLandingPage from "./components/CosmicLandingPage";
import LandingPageV2 from "./components/LandingPageV2";
import QuickOnboarding from "./components/QuickOnboarding";
import PersonalManifestoOnboarding from "./components/PersonalManifestoOnboarding";
import GuildCreationOnboarding from "./components/GuildCreationOnboarding";
import GameIntroduction from "./components/GameIntroduction";
import ToolFedAppsPage from "./components/ToolFedAppsPage";
import GameIntroMontage from "./components/GameIntroMontage";
import RefinedGameIntro from "./components/RefinedGameIntro";
import AboutPage from "./components/AboutPage";
import MobileChatInterface from "./components/MobileChatInterface";
import AuthSystem from "./components/AuthSystem";
import UserDashboard from "./components/UserDashboard";
import FounderDashboard from "./components/FounderDashboard";
import SuperUserDashboard from "./components/SuperUserDashboard";
import MessagingPage from "./components/MessagingPage";
import MyProjectsPage from "./components/MyProjectsPage";
import MultiplayerMessaging from "./components/MultiplayerMessaging";
import ProjectSalonInterface from "./components/ProjectSalonInterface";
import SpiralTrip from "./components/SpiralTrip";
import SonicExperience from "./components/SonicExperience";
import SimpleAuthentication from "./components/SimpleAuthentication";
import SystemWarningPage from "./components/SystemWarningPage";
import ComputerConsciousnessReveal from "./components/ComputerConsciousnessReveal";
import RealWorldFocusReveal from "./components/RealWorldFocusReveal";
import BelongingReminderPage from "./components/BelongingReminderPage";
import MultiPathLandingPage from "./components/MultiPathLandingPage";
import RemedyCouncilSystem from "./components/RemedyCouncilSystem";
import ReInnLanding from "./components/ReInnLanding";
import RoomOfThresholds from "./components/RoomOfThresholds";
import RoomOfGifts from "./components/RoomOfGifts";
import RoomOfMirrors from "./components/RoomOfMirrors";
import GuildHaus from "./components/GuildHaus";
import GlitchyReInnLanding from "./components/GlitchyReInnLanding";
import ProjectManagementApp from "./components/FamilyProjectBoard";
import GuildProjectManagement from "./components/GuildProjectManagement";
import GuildProjectManagementEnhanced from "./components/GuildProjectManagementEnhanced";
import UnifiedDashboard from "./components/UnifiedDashboard";
import GameplayIntroTerminal from "./components/GameplayIntroTerminal";
import SpiralOrgLandingNotebook from "./components/SpiralOrgLandingNotebook";
import SpiralOrgLandingMystical from "./components/SpiralOrgLandingMystical";
import SpiralOrgEpicLanding from "./components/SpiralOrgEpicLanding";
import SpiralOrgPremiumLanding from "./components/SpiralOrgPremiumLanding";
import SpiralOrgElegantLanding from "./components/SpiralOrgElegantLanding";
import SpiralOrgUltimateLanding from "./components/SpiralOrgUltimateLanding";
import SpiralOrgFinalLanding from "./components/SpiralOrgFinalLanding";
import SpiralOrgCinematicLanding from "./components/SpiralOrgCinematicLanding";
import SpiralOrgEntryPortal from "./components/SpiralOrgEntryPortal";
import SpiralOrgWhatIsThis from "./components/SpiralOrgWhatIsThis";
import SpiralOrgDirectory from "./components/SpiralOrgDirectory";
import SpiralOrgCinemaExperience from "./components/SpiralOrgCinemaExperience";
import SpiralCredInfo from "./components/SpiralCredInfo";
import LoreLibraryPage from "./components/LoreLibraryPage";
import SpiralOrganismInfo from "./components/SpiralOrganismInfo";
import SeedyPeepsInfo from "./components/SeedyPeepsInfo";
import RitesOfPresenceInfo from "./components/RitesOfPresenceInfo";
import DefianceSpringsInfo from "./components/DefianceSpringsInfo";
import FamilyReunionInfo from "./components/FamilyReunionInfo";
import ManifestoOnboarding from "./components/ManifestoOnboarding";

function App() {
  const [currentView, setCurrentView] = useState('spiralorg_entry'); // Start at entry portal
  // Views: 'spiralorg_entry', 'spiralorg_cinema', 'spiralorg_landing', 'spiralorg_cinematic', 'spiralorg_classic', 'spiralorg_manifesto', 'landing', 'unified_dashboard', 'reinn', 'reinn_terminal_direct', 'room_thresholds', 'room_gifts', 'room_mirrors', 'guild_haus', 'multipath', 'remedy_council', 'onboarding', 'sacred_tenets', 'manifesto_onboarding', 'guild_creation', 'game_intro', 'game_features', 'game_montage', 'system_warning', 'consciousness_reveal', 'realworld_focus', 'belonging_reminder', 'mobile_chat', 'auth', 'dashboard', 'founder', 'super', 'messaging', 'my_projects', 'about', 'toolfed', 'multiplayer', 'project_salon', 'project_management', 'spiral_trip', 'sonic_experience'
  const [playerName, setPlayerName] = useState('');
  const [playerData, setPlayerData] = useState(null);
  const [authenticatedUser, setAuthenticatedUser] = useState(null);
  const [landingVersion, setLandingVersion] = useState('ultimate'); // 'ultimate' (default), 'cinematic', or 'classic'
  const [reinnProfile, setReinnProfile] = useState(null); // Store Re-Inn profile data

  // Make navigation handlers globally available  
  useEffect(() => {
    window.handleNavigateToMyProjects = handleNavigateToMyProjects;
    window.handleNavigateToAbout = handleNavigateToAbout;
    window.handleTestLandingV2 = handleTestLandingV2;
    window.handleNavigateToToolFed = handleNavigateToToolFed;
    window.handleNavigateToGuildHaus = () => setCurrentView('unified_dashboard');
    window.handleNavigateToReInnTerminal = () => setCurrentView('reinn_terminal_direct');
    window.handleNavigateToSecretHistory = () => setCurrentView('sacred_tenets');
    // SpiralORG version toggles
    window.toggleSpiralOrgVersion = () => {
      setLandingVersion(prev => prev === 'notebook' ? 'mystical' : 'notebook');
      setCurrentView('spiralorg_landing');
      console.log(`🌀 SPIRALORG: Toggled to ${landingVersion === 'notebook' ? 'mystical' : 'notebook'} version`);
    };
    window.goToManifesto = () => setCurrentView('spiralorg_manifesto');
    window.goToProjects = () => setCurrentView('project_management');
    return () => {
      delete window.handleNavigateToMyProjects;
      delete window.handleNavigateToAbout;
      delete window.handleTestLandingV2;
      delete window.handleNavigateToToolFed;
      delete window.handleNavigateToGuildHaus;
      delete window.handleNavigateToReInnTerminal;
      delete window.handleNavigateToSecretHistory;
      delete window.toggleSpiralOrgVersion;
      delete window.goToManifesto;
      delete window.goToProjects;
    };
  }, [landingVersion]);

  // Check for landing page version in URL parameters
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const version = urlParams.get('version');
    
    if (version === 'mystical') {
      console.log('🌀 SPIRALORG: Mystical version selected');
      setLandingVersion('mystical');
    } else if (version === 'notebook') {
      console.log('📖 SPIRALORG: Notebook version selected');
      setLandingVersion('notebook');
    } else {
      // Default to epic version
      console.log('✨ SPIRALORG: Epic version (default)');
      setLandingVersion('epic');
    }
  }, []);

  // Check for existing authentication on mount - ALLOW FRESH START
  useEffect(() => {
    const token = localStorage.getItem('planetary_fed_token');
    const storedUser = localStorage.getItem('planetary_fed_user');
    
    // Check for fresh start parameter
    const urlParams = new URLSearchParams(window.location.search);
    const freshStart = urlParams.get('fresh') === 'true';
    
    if (freshStart) {
      console.log('🔄 FRESH START: Clearing stored authentication');
      localStorage.removeItem('planetary_fed_token');
      localStorage.removeItem('planetary_fed_user');
      setCurrentView('landing');
      return;
    }
    
    if (token && storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        setAuthenticatedUser(parsed);
        
        // Route based on user type - ONLY SUPER USERS AND FOUNDERS SKIP LANDING
        if (parsed.is_super_user) {
          setCurrentView('super');
        } else if (parsed.is_founder) {
          setCurrentView('founder');
        } else {
          // REGULAR USERS START AT LANDING PAGE FOR PROPER EXPERIENCE
          console.log('🏠 AUTHENTICATED USER: Starting at landing page for full experience');
          setCurrentView('landing');
        }
      } catch (e) {
        console.log('Auth data corrupted, starting fresh');
        localStorage.removeItem('planetary_fed_token');
        localStorage.removeItem('planetary_fed_user');
      }
    } else {
      // Check for quick game player
      const quickPlayer = localStorage.getItem('planetary_fed_player');
      if (quickPlayer) {
        try {
          const parsed = JSON.parse(quickPlayer);
          setPlayerData(parsed);
          setPlayerName(parsed.name);
          setCurrentView('mairy');
        } catch (e) {
          localStorage.removeItem('planetary_fed_player');
        }
      }
    }
  }, []);

  const handleNameSubmission = (name) => {
    setPlayerName(name);
    // Show gameplay intro first, then sacred tenets
    setCurrentView('gameplay_intro');
  };

  const handleGameplayIntroComplete = () => {
    setCurrentView('sacred_tenets');
  };

  const handleSacredTenetsComplete = (player) => {
    console.log('🎯 SIMPLE AUTHENTICATION COMPLETE:', player);
    setPlayerData(player);
    
    // Quick test mode - go directly to mobile chat for testing
    if (player.user?.name === "test" || player.user?.name === "debug") {
      console.log('🔧 TEST MODE: Going directly to mobile chat');
      setCurrentView('mobile_chat');
    } else {
      // Normal flow through manifesto onboarding
      console.log('🌟 PROPER FLOW: Going to personal manifesto onboarding');
      setCurrentView('manifesto_onboarding');
    }
  };

  const handleManifestoComplete = (enhancedPlayer) => {
    console.log('🌟 MANIFESTO COMPLETE:', enhancedPlayer);
    setPlayerData(enhancedPlayer);
    
    if (enhancedPlayer.guild_creation_requested) {
      // Go to guild creation
      setCurrentView('guild_creation');
    } else {
      // Go to game intro
      setCurrentView('game_features');
    }
  };

  const handleGuildCreationComplete = (guildFounder) => {
    console.log('🏰 GUILD CREATION COMPLETE:', guildFounder);
    setPlayerData(guildFounder);
    // After guild creation → Game intro
    setCurrentView('game_features');
  };

  const handleFeaturesComplete = () => {
    // After refined game intro → System Warning → Mobile Chat
    setCurrentView('system_warning');
  };

  const handleGameIntroComplete = () => {
    // After game intro text → System Warning → Mobile Chat
    setCurrentView('system_warning');
  };

  const handleMontageComplete = () => {
    // After montage → System Warning → Chat Interface
    setCurrentView('system_warning');
  };

  const handleMontageSkip = () => {
    setCurrentView('system_warning');
  };

  const handleOnboardingComplete = (player) => {
    setPlayerData(player);
    setCurrentView('game_intro'); // NEW: Go to intro first
  };

  const handleEnterGame = () => {
    setCurrentView('system_warning'); // NEW: Show system warning before mobile chat
  };
  
  const handleSystemWarningComplete = () => {
    setCurrentView('consciousness_reveal'); // Go to consciousness reveal page
  };
  
  const handleSkipToGame = () => {
    setCurrentView('mobile_chat'); // Skip directly to game
  };
  
  const handleConsciousnessRevealComplete = () => {
    setCurrentView('realworld_focus'); // Go to real world focus page
  };
  
  const handleRealWorldFocusComplete = () => {
    setCurrentView('belonging_reminder'); // Go to belonging reminder page
  };
  
  const handleBelongingReminderComplete = () => {
    setCurrentView('mobile_chat'); // Finally enter the game
  };

  const handleAuthenticated = (user) => {
    setAuthenticatedUser(user);
    
    // Route based on user privileges
    if (user.email === "macastat@gmail.com" || user.roles?.includes("super_user") || user.roles?.includes("founding")) {
      setCurrentView('super_dashboard');
    } else if (user.multiplayer_access) {
      setCurrentView('enhanced_dashboard');
    } else {
      setCurrentView('enhanced_dashboard');
    }
  };

  const handleNavigateHome = () => {
    setCurrentView('spiralorg_landing');
  };

  const handleNavigateToAuth = () => {
    setCurrentView('auth');
  };
  
  // Multi-path landing navigation
  const handleNavigateToMultiPath = () => {
    setCurrentView('multipath');
  };
  
  const handleSpiralCouncilPath = () => {
    setCurrentView('remedy_council'); // Go to spiral council system
  };
  
  const handleProjectsPath = () => {
    setCurrentView('messaging'); // Go to projects page
  };
  
  const handleGameplayPath = () => {
    setCurrentView('sacred_tenets'); // Begin full consciousness expansion
  };
  
  // Re-Inn navigation handlers
  const handleEnterAsGiveth = () => {
    setCurrentView('room_thresholds');
    setReinnProfile({ userType: 'giveth' });
  };
  
  const handleEnterAsGet = () => {
    setCurrentView('room_thresholds');
    setReinnProfile({ userType: 'get' });
  };
  
  const handleThresholdSelected = (thresholdData) => {
    setReinnProfile(prev => ({ ...prev, ...thresholdData }));
    setCurrentView('room_gifts');
  };
  
  const handleGiftSelected = (giftData) => {
    setReinnProfile(prev => ({ ...prev, ...giftData }));
    setCurrentView('room_mirrors');
  };
  
  const handleEnterFederation = () => {
    // Route directly to Guild Haus dashboard (not Sacred Tenets)
    setPlayerData({
      name: `${reinnProfile.giftName} Bearer`,
      avatar_name: reinnProfile.giftName,
      reinn_profile: reinnProfile,
      access_level: 'federation_member'
    });
    setCurrentView('guild_haus');
  };

  const handleNavigateToGame = () => {
    // For "Back to Game" - go directly to mobile chat (skip terminals)
    if (playerData || authenticatedUser) {
      setCurrentView('mobile_chat'); 
    } else {
      setCurrentView('landing');
    }
  };
  
  const handleStartNewGame = () => {
    // For new users - go through terminal sequence
    if (playerData) {
      setCurrentView('system_warning'); 
    } else {
      setCurrentView('landing');
    }
  };

  const handleNavigateToMyProjects = () => {
    setCurrentView('project_management'); // Use new project management app
  };

  const handleNavigateToAbout = () => {
    setCurrentView('about');
  };

  const handleTestLandingV2 = () => {
    console.log('🚀 TESTING: Switching to Landing Page V2');
    setLandingVersion('v2');
    setCurrentView('landing');
  };

  const handleNavigateToToolFed = () => {
    setCurrentView('toolfed');
  };

  const handleNavigateToMultiplayer = () => {
    setCurrentView('multiplayer');
  };

  const handleNavigateToMessaging = () => {
    // ALL navigation now goes to unified Project Salons
    setCurrentView('messaging');
  };

  const handleNavigateToProjects = () => {
    setCurrentView('project_management'); // Navigate to new project management app
  };

  const handleNavigateToSpiralTrip = () => {
    setCurrentView('spiral_trip');
  };

  const handleNavigateToSonicExperience = () => {
    setCurrentView('sonic_experience');
  };

  const handleNavigateToSuperDashboard = () => {
    setCurrentView('super_dashboard');
  };

  const handleNavigateToEnhancedDashboard = () => {
    setCurrentView('enhanced_dashboard');
  };

  const handleNavigateToProjectSalon = () => {
    setCurrentView('project_salon');
  };

  const handleLogout = () => {
    localStorage.removeItem('planetary_fed_token');
    localStorage.removeItem('planetary_fed_user');
    localStorage.removeItem('planetary_fed_player');
    setAuthenticatedUser(null);
    setPlayerData(null);
    setCurrentView('landing');
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case 'onboarding':
        return (
          <QuickOnboarding 
            playerName={playerName}
            onComplete={handleOnboardingComplete}
          />
        );
      
      case 'multipath':
        return (
          <MultiPathLandingPage 
            onNavigateToSpiralCouncil={handleSpiralCouncilPath}
            onNavigateToProjects={handleProjectsPath}
            onNavigateToGameplay={handleGameplayPath}
          />
        );
      
      case 'reinn':
        return (
          <GlitchyReInnLanding 
            onEnterAsGiveth={handleEnterAsGiveth}
            onEnterAsGet={handleEnterAsGet}
            onNavigateToSecretHistory={() => setCurrentView('landing')}
          />
        );
      
      case 'reinn_terminal_direct':
        return (
          <GlitchyReInnLanding 
            onEnterAsGiveth={handleEnterAsGiveth}
            onEnterAsGet={handleEnterAsGet}
            onNavigateToSecretHistory={() => setCurrentView('landing')}
          />
        );
      
      case 'room_thresholds':
        return (
          <RoomOfThresholds 
            userType={reinnProfile?.userType}
            onThresholdSelected={handleThresholdSelected}
            onNavigateBack={() => setCurrentView('reinn')}
          />
        );
      
      case 'room_gifts':
        return (
          <RoomOfGifts 
            thresholdData={reinnProfile}
            onGiftSelected={handleGiftSelected}
            onNavigateBack={() => setCurrentView('room_thresholds')}
          />
        );
      
      case 'room_mirrors':
        return (
          <RoomOfMirrors 
            profileData={reinnProfile}
            onEnterFederation={handleEnterFederation}
            onNavigateBack={() => setCurrentView('room_gifts')}
          />
        );
      
      case 'guild_haus':
        return (
          <GuildHaus 
            profileData={reinnProfile}
            onNavigateToProjects={() => setCurrentView('messaging')}
            onNavigateToSecretHistory={() => setCurrentView('sacred_tenets')}
            onNavigateToRetreat={() => alert('Sacred retreat booking system - Connect with consciousness expansion properties worldwide!')}
          />
        );
      
      case 'remedy_council':
        return (
          <RemedyCouncilSystem 
            onNavigateHome={handleNavigateHome}
            currentUser={playerData || authenticatedUser}
          />
        );
      
      case 'gameplay_intro':
        return (
          <GameplayIntroTerminal 
            onContinue={handleGameplayIntroComplete}
          />
        );

      case 'sacred_tenets':
        return (
          <SimpleAuthentication 
            onComplete={handleSacredTenetsComplete}
          />
        );
      
      case 'manifesto_onboarding':
        return (
          <PersonalManifestoOnboarding 
            player={playerData || authenticatedUser}
            onComplete={handleManifestoComplete}
          />
        );
      
      case 'guild_creation':
        return (
          <GuildCreationOnboarding 
            player={playerData || authenticatedUser}
            onComplete={handleGuildCreationComplete}
          />
        );
      
      case 'game_features':
        return (
          <RefinedGameIntro 
            player={playerData || authenticatedUser}
            onComplete={handleFeaturesComplete}
            onSkip={handleGameIntroComplete}
          />
        );
      
      case 'game_intro':
        return (
          <GameIntroduction 
            player={playerData || authenticatedUser}
            onComplete={handleGameIntroComplete}
            onSkip={handleMontageComplete}
          />
        );
      
      case 'game_montage':
        return (
          <GameIntroMontage 
            player={playerData || authenticatedUser}
            onComplete={handleMontageComplete}
            onSkip={handleMontageSkip}
          />
        );
      
      case 'system_warning':
        return (
          <SystemWarningPage 
            onContinue={handleSystemWarningComplete}
            onSkip={handleSkipToGame}
          />
        );
      
      case 'consciousness_reveal':
        return (
          <ComputerConsciousnessReveal 
            onContinue={handleConsciousnessRevealComplete}
          />
        );
      
      case 'realworld_focus':
        return (
          <RealWorldFocusReveal 
            onContinue={handleRealWorldFocusComplete}
          />
        );
      
      case 'belonging_reminder':
        return (
          <BelongingReminderPage 
            onContinue={handleBelongingReminderComplete}
          />
        );
      
      case 'belonging_reminder':
        return (
          <BelongingReminderPage 
            onContinue={handleBelongingReminderComplete}
          />
        );
      
      case 'mobile_chat':
        return (
          <MobileChatInterface 
            player={playerData || authenticatedUser}
            onNavigateHome={handleNavigateHome}
            onNavigateToSpiralTrip={handleNavigateToSpiralTrip}
            onNavigateToSonicExperience={handleNavigateToSonicExperience}
            onNavigateToMessaging={handleNavigateToMessaging}
            onNavigateToAuth={handleNavigateToAuth}
          />
        );
      
      case 'auth':
        return (
          <AuthSystem 
            onAuthenticated={handleAuthenticated}
          />
        );
      
      case 'dashboard':
        return (
          <UserDashboard 
            user={authenticatedUser}
            onNavigateToGame={handleNavigateToGame}
            onLogout={handleLogout}
          />
        );
      
      case 'founder':
        return (
          <FounderDashboard 
            user={authenticatedUser}
            onLogout={handleLogout}
          />
        );
      
      case 'super':
        return (
          <SuperUserDashboard 
            user={authenticatedUser}
            onLogout={handleLogout}
          />
        );
      
      case 'messaging':
        return (
          <MessagingPage 
            player={playerData || authenticatedUser}
            onNavigateHome={handleNavigateHome}
            onNavigateToGame={handleNavigateToGame}
            onNavigateToMultiplayer={handleNavigateToMultiplayer}
          />
        );
      
      case 'my_projects':
        return (
          <MyProjectsPage 
            player={playerData || authenticatedUser}
            onNavigateHome={handleNavigateHome}
            onNavigateToGame={handleNavigateToGame}
          />
        );
      
      case 'about':
        return (
          <AboutPage 
            onNavigateHome={handleNavigateHome}
            onNavigateToGame={handleNavigateToGame}
          />
        );
      
      case 'toolfed':
        return (
          <ToolFedAppsPage 
            onNavigateHome={handleNavigateHome}
            onNavigateToGame={handleNavigateToGame}
          />
        );
      
      case 'multiplayer':
        return (
          <MultiplayerMessaging 
            user={authenticatedUser}
            onNavigateHome={handleNavigateHome}
          />
        );
      
      case 'super_dashboard':
        return (
          <SuperUserDashboard 
            user={authenticatedUser}
            onLogout={handleLogout}
          />
        );
      
      case 'enhanced_dashboard':
        return (
          <EnhancedUserDashboard 
            user={authenticatedUser}
            onNavigateToGame={handleNavigateToGame}
            onNavigateToMultiplayer={handleNavigateToMessaging}
            onLogout={handleLogout}
          />
        );
      
      case 'spiral_trip':
        return (
          <SpiralTrip 
            player={playerData || authenticatedUser}
            onNavigateHome={handleNavigateHome}
            onNavigateToGame={handleNavigateToGame}
          />
        );
      
      case 'sonic_experience':
        return (
          <SonicExperience 
            player={playerData || authenticatedUser}
            onNavigateToGame={handleNavigateToGame}
            onNavigateHome={handleNavigateHome}
          />
        );
      
      case 'project_salon':
        return (
          <ProjectSalonInterface 
            player={playerData || authenticatedUser}
            onNavigateHome={handleNavigateHome}
            onNavigateToGame={handleNavigateToGame}
          />
        );
      
      case 'unified_dashboard':
        return (
          <UnifiedDashboard 
            player={playerData || authenticatedUser}
            onNavigateToGame={() => setCurrentView('sacred_tenets')}
            onNavigateToProjects={() => setCurrentView('project_management')}
            onNavigateToRetreat={() => alert('Sacred retreat booking - Connect with Guild properties worldwide!')}
            onNavigateHome={handleNavigateHome}
          />
        );
      
      case 'project_management':
        return (
          <GuildProjectManagement 
            player={playerData || authenticatedUser}
            onNavigateBack={handleNavigateHome}
            userToken={localStorage.getItem('planetary_fed_token')}
          />
        );
      
      case 'spiralorg_entry':
        // ⭐ MAIN LANDING PAGE - PRIMARY ENTRY POINT ⭐ (Page 1)
        // THIS IS THE MAIN EFFECT LANDING PAGE - REFERENCE SpiralOrgEntryPortal.jsx FOR CHANGES
        // Features: Full-screen video + ORIGINAL Grant spiral rotation (Secret History style)
        return (
          <SpiralOrgEntryPortal 
            onProceedToCinema={() => setCurrentView('spiralorg_cinema')}
          />
        );
      
      case 'spiralorg_cinema':
        // Cinema Experience - Film of the Day theater (Page 2)
        return (
          <SpiralOrgCinemaExperience 
            onProceedToMain={() => setCurrentView('spiralorg_what')}
            onNavigateToAuth={() => setCurrentView('sacred_tenets')}
          />
        );
      
      case 'spiralorg_what':
        // What Is SpiralOrg - Strategic Declaration (Page 3)
        return (
          <SpiralOrgWhatIsThis 
            onProceedToCinema={() => setCurrentView('spiralorg_directory')}
          />
        );
      
      case 'spiralorg_directory':
        // Directory - Navigation Hub (Page 4)
        return (
          <SpiralOrgDirectory 
            onNavigateToOrganizer={() => setCurrentView('project_management')}
            onNavigateToSpiralCred={() => setCurrentView('spiralcred_info')}
            onNavigateToSpiralCouncil={() => setCurrentView('spiral_council_info')}
            onNavigateToLoreLibrary={() => setCurrentView('lore_library')}
            onNavigateToConsciousStock={() => setCurrentView('conscious_stock')}
            onNavigateToTrustWoven={() => setCurrentView('trustwoven_info')}
            onNavigateToGrantHicks={() => setCurrentView('grant_hicks_info')}
            onNavigateToSoulSeers={() => setCurrentView('soul_seers_info')}
            onNavigateToInterNorthern={() => setCurrentView('internorthern_info')}
            onNavigateToSecretHistory={() => setCurrentView('sacred_tenets')}
            onNavigateToSpiralOrganism={() => setCurrentView('spiral_organism')}
            onNavigateToSeedyPeeps={() => setCurrentView('seedy_peeps')}
            onNavigateToRitesOfPresence={() => setCurrentView('rites_of_presence')}
            onNavigateToDefianceSprings={() => setCurrentView('defiance_springs')}
            onNavigateToFamilyReunions={() => setCurrentView('family_reunions')}
            onNavigateToOnboarding={() => setCurrentView('spiralorg_manifesto')}
          />
        );

      case 'spiralcred_info':
        return <SpiralCredInfo onBackToDirectory={() => setCurrentView('spiralorg_directory')} onNavigateToOnboarding={() => setCurrentView('spiralorg_manifesto')} />;
      
      case 'spiral_council_info':
        return <SpiralCouncilInfo onBackToDirectory={() => setCurrentView('spiralorg_directory')} onNavigateToOnboarding={() => setCurrentView('spiralorg_manifesto')} />;
      
      case 'lore_library':
        return <LoreLibraryPage onBackToDirectory={() => setCurrentView('spiralorg_directory')} onNavigateToOnboarding={() => setCurrentView('spiralorg_manifesto')} />;
      
      case 'conscious_stock':
        return <ConsciousStockInfo onBackToDirectory={() => setCurrentView('spiralorg_directory')} onNavigateToOnboarding={() => setCurrentView('spiralorg_manifesto')} />;
      
      case 'trustwoven_info':
        return <TrustWovenInfo onBackToDirectory={() => setCurrentView('spiralorg_directory')} onNavigateToOnboarding={() => setCurrentView('spiralorg_manifesto')} />;
      
      case 'grant_hicks_info':
        return <GrantHicksInfo onBackToDirectory={() => setCurrentView('spiralorg_directory')} />;
      
      case 'soul_seers_info':
        return <SoulSeersInfo onBackToDirectory={() => setCurrentView('spiralorg_directory')} />;
      
      case 'internorthern_info':
        return <InterNorthernInfo onBackToDirectory={() => setCurrentView('spiralorg_directory')} onNavigateToOnboarding={() => setCurrentView('spiralorg_manifesto')} />;
      
      case 'spiral_organism':
        return <SpiralOrganismInfo onBackToDirectory={() => setCurrentView('spiralorg_directory')} onNavigateToOnboarding={() => setCurrentView('spiralorg_manifesto')} />;
      
      case 'seedy_peeps':
        return <SeedyPeepsInfo onBackToDirectory={() => setCurrentView('spiralorg_directory')} onNavigateToOnboarding={() => setCurrentView('spiralorg_manifesto')} />;
      
      case 'rites_of_presence':
        return <RitesOfPresenceInfo onBackToDirectory={() => setCurrentView('spiralorg_directory')} />;
      
      case 'defiance_springs':
        return <DefianceSpringsInfo onBackToDirectory={() => setCurrentView('spiralorg_directory')} />;
      
      case 'family_reunions':
        return <FamilyReunionInfo onBackToDirectory={() => setCurrentView('spiralorg_directory')} onNavigateToOnboarding={() => setCurrentView('spiralorg_manifesto')} />;

      
      case 'spiralorg_landing':
        // SpiralORG Landing - Epic version (default) or legacy versions
        if (landingVersion === 'mystical') {
          return (
            <SpiralOrgLandingMystical 
              onEnterProjects={() => setCurrentView('project_management')}
              onCreateManifesto={() => setCurrentView('spiralorg_manifesto')}
              onEnterReInn={() => setCurrentView('reinn')}
            />
          );
        } else if (landingVersion === 'notebook') {
          return (
            <SpiralOrgLandingNotebook 
              onEnterProjects={() => setCurrentView('project_management')}
              onCreateManifesto={() => setCurrentView('spiralorg_manifesto')}
              onEnterReInn={() => setCurrentView('reinn')}
            />
          );
        } else {
          // Render based on landingVersion - ultimate is default
          if (landingVersion === 'classic') {
            return (
              <SpiralOrgFinalLanding 
                onExploreMembers={() => setCurrentView('spiralorg_manifesto')}
                onBeginJourney={() => setCurrentView('spiralorg_manifesto')}
                onEnterProjects={() => setCurrentView('project_management')}
                onSwitchToCinematic={() => setLandingVersion('ultimate')}
              />
            );
          } else if (landingVersion === 'cinematic') {
            return (
              <SpiralOrgCinematicLanding 
                onBeginJourney={() => setCurrentView('spiralorg_manifesto')}
                onEnterProjects={() => setCurrentView('project_management')}
                onSwitchToClassic={() => setLandingVersion('classic')}
              />
            );
          } else {
            // Default: Ultimate landing with anamorphic letterbox, verbatim copy
            return (
              <SpiralOrgUltimateLanding 
                onEnterProjects={() => setCurrentView('project_management')}
                onSwitchToAlternate={() => setLandingVersion('cinematic')}
              />
            );
          }
        }
      
      case 'spiralorg_manifesto':
        return (
          <ManifestoOnboarding 
            onComplete={(manifestoData) => {
              console.log('✅ Manifesto completed:', manifestoData);
              setCurrentView('project_management');
            }}
            onSkip={() => setCurrentView('project_management')}
          />
        );
      
      case 'landing':
        // Version toggle for testing both landing pages
        if (landingVersion === 'v2') {
          return (
            <LandingPageV2 
              onNameSubmission={handleNameSubmission}
              onNavigateToAuth={handleNavigateToAuth}
              onNavigateToMessaging={handleNavigateToMessaging}
              onNavigateToProjects={handleNavigateToProjects}
            />
          );
        } else {
          return (
            <CosmicLandingPage 
              onNameSubmission={handleNameSubmission}
              onNavigateToAuth={handleNavigateToAuth}
              onNavigateToMessaging={handleNavigateToMessaging}
              onNavigateToProjects={handleNavigateToProjects}
              onNavigateToReinn={() => setCurrentView('reinn')}
            />
          );
        }
      
      case 'landing_v2_test':
        // Direct access to Landing Page V2 for testing
        return (
          <LandingPageV2 
            onNameSubmission={handleNameSubmission}
            onNavigateToAuth={handleNavigateToAuth}
            onNavigateToMessaging={handleNavigateToMessaging}
            onNavigateToProjects={handleNavigateToProjects}
          />
        );
      
      default:
        return (
          <CosmicLandingPage 
            onNameSubmission={handleNameSubmission}
            onNavigateToAuth={handleNavigateToAuth}
            onNavigateToMessaging={handleNavigateToMessaging}
            onNavigateToProjects={handleNavigateToProjects}
            onNavigateToReinn={() => setCurrentView('reinn')}
          />
        );
    }
  };

  return (
    <div className="App">
      <BrowserRouter>
        {renderCurrentView()}
      </BrowserRouter>
    </div>
  );
}

export default App;